export enum PaymentMethodTypesEnum {
    All = 0,
    Cash = 1,
    Check = 2,
    CustomerAccount = 5,
    ThirdParty = 6,
    CashAdjustmentPosAmount = 8,
    CashAdjustmentNegAmount = 11,
    Credit = 12,
    PrepaidVoucher = 13,
    MVDCredit = 21,
    POSCredit = 22,
    POSCheck = 23,
    CreditCustomerAccount = 24,
    Other = 99
}

export enum JournalEntryTypesEnum {
    HURF = 1,
    VLT = 2,
    Transaction = 3,
    Manual = 4,
    AFISTransfer = 5,
    HURFClose = 6,
    VLTClose = 7
}

export enum JournalEntryStatusTypesEnum {
    Pending = 1,
    Posted = 2
}

export enum JournalEntryTemplateTypesEnum {
    Standard = 1,
    BalanceTransfer = 2,
    Recurring = 3
}

export enum JournalEntryTemplateFrequencyTypesEnum {
    None = 1,
    Daily = 2,
    Weekly = 3,
    Monthly = 4,
    Yearly = 5
}

export enum DisplaySection {
    Search = 1,
    Edit = 2,
    View = 3,
    Print = 4
}

export enum GeneralLedgerAccountType {
    Asset = 1,
    Liability = 2,
    Equity = 3,
    Revenue = 4,
    Expense = 5
}

export enum GeneralLedgerAssetsLiabilitiesSearchType {
    BalanceDate = 1,
    FiscalPeriod = 2
}

export enum ReconciliationStatusTypesEnum {
    Unreconciled = 1,
    Partial = 2,
    Reconciled = 3,
    Processed = 4,
    Pending = 5,
    All = 6
}

export enum FinanceBankStatementRecordType {
    Credit = 1,
    Debit = 2,
    Dck = 3
}

export enum FinanceBankStatementCodeType {
    ThreeHundredOne = 14,
    FourHundredFiftyOne = 19,
    FiveHundredFiftyFive = 27,
    FiveHundredAndFiftySeven = 28,
    FiveHundredAndSixtySix = 29
}

export enum PPVAdjustmentType {
    Increase = 1,
    Decrease = 2
}

export enum BusinessTransactionTypesEnum {
    FundCustomerAccount = 56,
    CountyMiscellaneousPurchase = 1111
}

export enum HURFBreakdownAddSubtractTypesEnum {
    Add = 1,
    Subtract = 2
}

export enum HURFBreakdownAmountPercentTypesEnum {
    Amount = 1,
    Percent = 2
}

export enum HURFBreakdownItemTypesEnum {
    EconomicStrength = 1,
    DeptPublicSafety = 2,
    AllocationDeptPublicSafety = 3,
    AllocationMVD = 4,
    CountyAllocation = 5,
    IncorpCitiesTowns = 6,
    CitiesPopulation300000 = 7,
    CountiesPopulation800000 = 8,
    StateLakeImprovementFund = 9,
    StateLakeImprovementAdmin = 10,
    OffHighwayRecFund = 11
}

export enum FinanceDisbursementRequestTypesEnum {
    CheckDisbursement = 1,
    DigitalDisbursement = 2,
    FTVendor = 3,
    FTForeignIFTA = 4,
    FTArizonaIFTA = 5,
    FTTribalMember = 6,
    FTTribalGov = 7,
    FTExporter = 8,
    FTMotorVehicle = 9,
    FTAviation = 10,
    FTForestProducts = 11,
    FTOffRoad = 12,
    FTBulk = 13,
    FTContaminationOther = 14
}

export enum FinanceDisbursementRequestStatusTypesEnum {
    Pending = 1,
    Approved = 2,
    Denied = 3,
    Issued = 4,
    Digital = 5,
    Preparing = 6,
    Assigned = 7,
    Processed = 8,
    SenttoAFIS = 9
}

export enum ProductsEnum {
    LUFDORUseTax = 10220,
    RentalSurcharge = 10158
}

export enum FinanceBankAccountsEnum {
    BOfAFuelTaxACHCredit = 17,
    BOfAFuelTaxACHCreditUST = 18,
    ChaseFuelTaxACHCredit = 23
}

export enum BusinessUnitsEnum {
    FuelTax = 1018
}

export enum DepositAdjustmentTypesEnum {
    OverShort = 1,
    MerchantFees = 2,
    RetainedAmount = 3,
    MCarrierAdjustment = 4,
    Reversal = 5
}

export enum FinanceVLTAdjustmentTypesEnum {
    RegCompliance = 1,
    Miscellaneous = 2
}

export enum FinanceVLTTypesEnum {
    New = 1,
    Used = 3,
    Alt = 4,
    Used35 = 5,
    Alt35 = 6
}

export enum FinanceGLAccountsEnum {
    HURFPayable = 127
}

export enum FuelTaxCustomerLedgerDisplayTypesEnum {
    All = 1,
    Excise = 2,
    UST = 3
}

export enum DisbursementSearchDateRangeTypesEnum {
    ReceivedDate = 1,
    IssuedDate = 2
}

export enum QueueItemStatusTypesEnum {
    NotProcessed = 1,
    InProgress = 2,
    Completed = 3,
    Failed = 4
}
